import { useMemo } from "react";
import {
  TextField,
  DatagridConfigurable,
  DateField,
  NumberField,
  useTheme,
} from "react-admin";
import DownloadAction from "../../components/tableListActions/DownloadActionNew";
import getFirstAndLastDateOfCurrentMonth from "../../utils/firstLastDate";
import journalMemorialFilterList from "../../components/journalMemorials/filter/journalMemorialFilterList";
import JournalMemorialExpandList from "../../components/journalMemorials/expand/JournalMemorialExpandList";
import ManualReportList from "../../components/reports/ManualReportList";
import useCompanyScopedListFilters from "../../hooks/useCompanyScopedListFilters";

const [firstDate, lastDate] = getFirstAndLastDateOfCurrentMonth();

const JournalMemorialList = () => {
  const { permissions, canSeeCompanyColumn, filterDefaultValues } =
    useCompanyScopedListFilters({
      start_date: firstDate,
      end_date: lastDate,
      approved: 1,
    });
  const [theme] = useTheme("light");

  const list = useMemo(
    () => (
      <ManualReportList
        title="mine.list_title.journal_memorial"
        empty={false}
        actions={<DownloadAction />}
        filters={journalMemorialFilterList(permissions, { includeCompany: false })}
        // sort={{ field: "code", order: "ASC" }}
        queryOptions={{ meta: { sort: ["journals.code ASC"] } }} // overide default sort
        filterDefaultValues={filterDefaultValues}
        requiredFilters={["start_date", "end_date"]}
      >
        <DatagridConfigurable
          // FIXME: semua datagrid perlu pake custom bulk action ini
          bulkActionButtons={false}
          expand={<JournalMemorialExpandList />}
          sx={{
            "& .RaDatagrid-expandedPanel > td": {
              p: 0,
              bgcolor: theme !== "dark" ? "#E7EBF0" : "grey.800",
            },
          }}
        >
          {canSeeCompanyColumn ? (
            <TextField source="company.alias" label="mine.label.depo" />
          ) : null}
          <TextField source="code" label="mine.label.receipt_no" />
          <DateField
            source="date"
            label="mine.label.date"
            options={{
              year: "numeric",
              month: "short",
              day: "2-digit",
            }}
          />
          <TextField
            source="category.name"
            label="mine.label.category"
            emptyText="-"
          />
          <TextField source="creator_name" label="mine.label.created_by" />
          <DateField
            source="created_at"
            label="mine.label.created_at"
            showTime
          />
          <TextField source="note" label="mine.label.note" />
          <NumberField source="total" />
        </DatagridConfigurable>
      </ManualReportList>
    ),
    [theme, permissions, canSeeCompanyColumn, filterDefaultValues]
  );
  return list;
};

export default JournalMemorialList;
